import { useQuery } from '@tanstack/react-query';
import {
  getProductCategories,
  getProductCategoryById,
  ProductCategoryQueryParams,
} from '@lib/data/product-category-data';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import {
  buildFullProductCategory,
  buildProductCategories,
} from '../utils/products/product-categories';

export const useProductCategories = ({
  expand,
  parent_category_id,
  fields,
}: ProductCategoryQueryParams) => {
  const { i18n } = useTranslation();

  const queryKey = useMemo(
    () => [
      'productCategories',
      { expand, parent_category_id, fields } as ProductCategoryQueryParams,
      i18n.language,
    ],
    [expand, parent_category_id, fields, i18n.language],
  );

  const {
    data: categories,
    isError,
    isLoading,
  } = useQuery(queryKey, getProductCategories, {
    select: buildProductCategories,
  });

  return { categories, isError, isLoading } as const;
};

export const useProductCategory = (
  id: string,
  fields: string,
  expand: string,
) => {
  const { i18n } = useTranslation();

  const queryKey = useMemo(
    () => [
      'productCategory',
      { parent_category_id: id, fields, expand } as ProductCategoryQueryParams,
      i18n.language,
    ],
    [id, fields, expand, i18n.language],
  );

  const { data } = useQuery(queryKey, getProductCategoryById, {
    select: buildFullProductCategory,
  });

  return { ...data } as const;
};
